/**
 * DASHBOARD ROUTES
 */
const routes = [
  {
    path: '/Inicio',
    name: 'HomeViewComponent',
    component: 'Dashboard/HomeViewComponent'
  }
];

export default routes;
